<template>
  <div class="fullbox">
    <div class="crumbs">
      <!-- <div class="goBack" @click="goBack">
          <i class="el-icon-arrow-left"></i> 返回
        </div>
        <div class="title">分类管理</div> -->
      <div class="title">{{ objectList.name }}</div>
      <i class="el-icon-arrow-right"></i>
      <!-- <div class="title">二级标题</div>
      <i class="el-icon-arrow-right"></i> -->
      <div class="title title1">文章详情</div>
    </div>
    <div class="container">
      <div class="box" ref="boxElement">
        <div class="title-h1">
          {{ objectList.title }}
        </div>
        <div class="timeDate">
          {{ timeDate }}
        </div>
        <div class="list_text">
          <div v-html="objectList.content" class="htmlClass"></div>
        </div>
        <div class="give_collect">
          <div style="font-size: 14px; text-align: center">
            <img src="@/assets/logistics/giveUp.png" alt="" @click="giveUp" v-if="!objectList?.likes" />
            <img src="@/assets/logistics/giveUpActive.png" alt="" @click="giveUp" v-else />
            <div>{{ objectList?.likes }}赞</div>
          </div>
          <!-- <img src="@/assets/logistics/collect.png" alt="" /> -->
        </div>
        <div class="comment">
          <div class="comment_num">评论{{ objectList.comments }}</div>
          <div class="comment_my">
            <div class="avatar">
              <img :src="$store.state.userInfo.icon" alt="" />
            </div>
            <div class="comment_input">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="说点什么吧"
                v-model="textarea"
              >
              </el-input>
              <div class="btn" @click="submitComment(null)">提交评论</div>
            </div>
          </div>
          <!-- <div class="commment_checkbox">
          <el-checkbox v-model="checked">有人回复我时邮件通知我</el-checkbox>
        </div> -->
          <div class="comment_list">
            <div class="comment_item" v-for="item in list" :key="item.id">
              <div class="avatar">
                <img :src="item.avatar" alt="" />
                <div class="name">
                  {{ item.nickName }}
                </div>
              </div>
              <div class="reason">
                {{ item.content }}
              </div>
              <div class="reply">
                <div class="r1" @click="clickReply(item)">
                  {{ item.showInput ? "收起回复" : "回复" }}
                </div>
                <span>·</span>
                <div>{{ item.timeAgo }}</div>
              </div>
              <div class="comment_input" v-if="item.showInput">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="说点什么吧"
                  v-model="item.value"
                >
                </el-input>
                <div class="btn" @click="submitComment(item)">提交评论</div>
              </div>
              <!-- <div
              class="children_list"
              v-if="item.showChildren && item.children.length > 0"
            >
              <div
                class="children_item"
                v-for="child in item.children"
                :key="child.id"
              >
                <div class="avatar">
                  <img :src="child.img" alt="" />
                  <div class="name">
                    {{ child.name }}
                  </div>
                </div>
                <div class="reason">
                  {{ child.reason }}
                </div>
                <div class="reply">
                  <div>{{ child.time }}</div>
                </div>
              </div>
            </div> -->
              <!-- <div
              class="child_comment"
              v-if="item.children.length > 0"
              @click="clickChildren(item)"
            >
              {{ item.showChildren ? "收起" : "查看" }}全部{{
                item.children.length
              }}条回复
            </div> -->
            </div>
            <div
              class="comment_footer"
              @click="clickFooter1"
              v-if="allList.length > 5 && commentFooter"
            >
              点击查看所有{{ allList.length }}条评论
            </div>
            <div
              class="comment_footer"
              @click="clickFooter2"
              v-if="allList.length > 5 && !commentFooter"
            >
              收起评论
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/logistics";
import { redirectRoute } from "@/utils/tools";
import { getToken } from "@/utils/cookie";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      textarea: "",
      checked: false,
      list: [],
      commentFooter: true,
      id: "",
      objectList: {},
      allList: [],
      userInfo: {},
      ipAddress: "",
      timeDate:'',
    };
  },
  mounted() {
    const { id } = this.$route.query;
    this.id = id;
    setTimeout(() => {
      this.getList();
    }, 100);
    this.getQueryComment();
    this.getUserinfo();
    this.getIPAddress();
  },
  methods: {
    //获取当前 IP 地址
    async getIPAddress() {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        this.ipAddress = data.ip;
        console.log("当前 IP 地址：", this.ipAddress);
      } catch (error) {
        console.error("获取 IP 地址失败:", error);
      }
    },
    //提交评论
    async submitComment(item) {
      if (!item && !this.textarea) {
        return this.$message.warning("请输入评论");
      }

      const params = {
        userId: this.userInfo.id,
        aid: this.id,
        ip: this.userInfo.loginip,
        content: item ? item.value : this.textarea,
        pid: item ? item.userId : 0,
      };

      try {
        const res = await api.addComment(params);
        if (res.code == 200) {
          this.$message.success("评论成功");
          this.getQueryComment();

          if (item) {
            this.$set(item, "showInput", false);
          } else {
            this.textarea = "";
          }
        }
      } catch (error) {
        console.error("提交评论失败:", error);
      }
    },
    //收起回复&回复
    clickReply(item) {
      this.$set(item, "showInput", !item.showInput);
      this.$set(item, "value", `@${item.nickName + " "}`);
      this.$forceUpdate();
    },
    //查看所有评论
    clickFooter1() {
      this.commentFooter = false;
      this.getQueryComment();
    },
    //收起评论
    clickFooter2() {
      this.commentFooter = true;
      this.getQueryComment();
    },
    // 获取文章详情
    getList() {
      this.loading = true;
      api
        .queryArticleList({
          keyWord: "",
          menuId: "",
          page: 1,
          pageSize: 20,
          articleId: this.id,
        })
        .then((res) => {
          if (res.code == 200) {
            this.objectList = res.data.list[0];
            console.log(res.data.list[0],'res.data.list[0]');
            const time = res.data.list[0].publishtime
            this.timeDate = moment(time * 1000).format(
              "YYYY-MM-DD HH:mm:ss");
              
            const redirect = redirectRoute();
            if (!redirect) {
              this.$nextTick(() => {
                const targetElements = document.querySelectorAll("img"); // 获取所有 img 标签
                const targetVideo = document.querySelectorAll("video"); // 获取所有 img 标签
                if (targetElements.length > 0) {
                  // 检查是否找到 img 标签
                  targetElements.forEach((img) => {
                    img.style.width = "100%"; // 为每个 img 标签设置 width
                  });
                }
                if (targetVideo.length > 0) {
                  targetVideo.forEach((video) => {
                    video.style.width = "100%"; // 为每个 img 标签设置 width
                  });
                }
              });
            } else {
              this.$nextTick(() => {
                const targetElements = document.querySelectorAll("img"); // 获取所有 img 标签
                const targetVideo = document.querySelectorAll("video"); // 获取所有 img 标签
                const boxWidth = this.$refs.boxElement.clientWidth;
                // 获取类名为box的盒子的宽度

                console.log(boxWidth, "boxWidth");

                targetElements.forEach((img) => {
                  img.addEventListener("load", () => {
                    if (img.clientWidth > boxWidth) {
                      img.style.width = "100%";
                    }
                  });

                  // 如果图片已经加载完，直接修改宽度
                  if (img.complete && img.clientWidth > boxWidth) {
                    img.style.width = "100%";
                  }
                });
                if (targetVideo.length > 0) {
                  targetVideo.forEach((video) => {
                    // if (video.clientWidth > window.innerWidth) {
                    video.style.width = "100%"; // 为每个 video 标签设置 width
                    // }
                  });
                }
              });
            }
          }
        });
    },
    // 获取评论
    getQueryComment() {
      api
        .queryComment({
          id: this.id,
        })
        .then((res) => {
          if (res.code == 200) {
            this.list = res.data;
            this.allList = res.data;
            if (this.allList.length > 5 && this.commentFooter) {
              this.list = this.list.slice(0, 5);
            } else {
              this.list = res.data;
            }
            this.list.length > 0 &&
              this.list.forEach((item) => {
                item.showInput = false;
              });
          }
        });
    },
    // 获取用户信息
    getUserinfo() {
      api
        .queryUserInfo({
          code: getToken(),
        })
        .then((res) => {
          if (res.code == 200) {
            this.userInfo = res.data[0];
          }
        });
    },
    // 点赞
    giveUp() {
      api
        .like({
          id: this.id,
          userId: this.userInfo.id,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("点赞成功");
            this.getList();
          }
        });
    },
    // clickChildren(item) {
    //   item.showChildren = !item.showChildren;
    // },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .box{
    width: 100%;
    padding: 30px;
  }
  .list_text,
  .comment {
    padding: 40px;
  }
}
@media screen and (min-width: 600px) {
  .box{
    width: 50%;
    padding: 30px 0;
  }
  .list_text,
  .comment {
    // padding: 80px;
  }
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: hidden;
  padding: 40px;
  display: flex;
  flex-direction: column;
  .crumbs {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 20px;
    padding: 30px 40px;
    flex-wrap: wrap;
    // .goBack {
    //   font-size: 28px;
    //   color: rgba(102, 102, 102, 1);
    //   margin-right: 45px;
    //   cursor: pointer;
    //   i {
    //     margin-right: 10px;
    //   }
    // }
    .title {
      font-size: 28px;
    }
    i {
      margin: 0 10px;
    }
    .title1 {
      color: rgba(78, 162, 124, 1);
    }
  }
  .container {
    flex: 1;
    overflow-y: auto;
    margin-top: 40px;
    background: #fff;
    border-radius: 20px;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .box {
      // width: 50%;
      margin: 0 auto;
      .title-h1 {
        font-weight: bold;
        font-size: 56px;
      }
      .timeDate {
        font-size: 28px;
        color: rgba(102, 102, 102, 1);
        margin: 20px 0;
      }
    }
  }
  .list_text {
    .title {
      font-weight: bold;
      font-size: 48px;
    }
    .timeDate {
      font-size: 28px;
      color: rgba(102, 102, 102, 1);
      margin: 20px 0;
    }
    .s-1 {
      font-size: 30px;
      color: rgba(102, 102, 102, 1);
      line-height: 50px;
    }
    .s-2 {
      font-size: 30px;
      color: rgba(102, 102, 102, 1);
      line-height: 50px;
      text-indent: 2em;
      margin-top: 20px;
    }
  }
  .give_collect {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100px !important;
      height: 100px !important;
      margin-bottom: 10px;
    }
    img:nth-child(1) {
      // margin-right: 80px;
    }
  }
  .comment {
    .comment_num {
      font-size: 46px;
      color: #000;
      font-weight: bold;
    }
    .comment_my {
      display: flex;
      align-items: flex-start;
      margin-top: 40px;
      .avatar {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 20px;
        img {
          width: 100% !important;
          height: 100% !important;
        }
      }
      .comment_input {
        flex: 1;
        background: rgba(250, 250, 250, 1);
        border-radius: 20px;
        ::v-deep {
          .el-textarea__inner {
            background: rgba(250, 250, 250, 1);
            border-radius: 20px;
            font-size: 26px;
            padding: 30px;
            border: none;
            resize: none;
          }
        }
        .btn {
          width: 200px;
          height: 60px;
          background: rgba(79, 162, 125, 0.5);
          border-radius: 10px;
          text-align: center;
          line-height: 60px;
          color: #fff;
          margin: 20px 40px 40px 0;
          font-size: 26px;
          float: right;
          cursor: pointer;
        }
      }
    }
    .commment_checkbox {
      padding-left: 80px;
      margin-top: 20px;
    }
    .comment_list {
      margin-top: 40px;
      .comment_item {
        margin-top: 40px;
        .avatar {
          display: flex;
          align-items: center;
          img {
            width: 60px !important;
            height: 60px !important;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 20px;
          }
          .name {
            font-weight: bold;
            font-size: 30px;
          }
        }
        .reason {
          padding-left: 80px;
          font-size: 26px;
          color: rgba(8, 10, 18, 1);
        }
        .reply {
          padding-left: 80px;
          font-size: 26px;
          color: rgba(150, 155, 158, 1);
          display: flex;
          align-items: center;
          margin: 20px 0;
          span {
            margin: 0 20px;
          }
          .r1 {
            color: #000;
          }
        }
        .comment_input {
          flex: 1;
          background: rgba(250, 250, 250, 1);
          border-radius: 20px;
          margin: 20px 0 20px 80px;
          height: 335px;
          ::v-deep {
            .el-textarea__inner {
              background: rgba(250, 250, 250, 1);
              border-radius: 20px;
              font-size: 26px;
              padding: 30px;
              border: none;
              resize: none;
            }
          }
          .btn {
            width: 200px;
            height: 60px;
            background: rgba(79, 162, 125, 0.5);
            border-radius: 10px;
            text-align: center;
            line-height: 60px;
            color: #fff;
            margin: 20px 40px 40px 0;
            font-size: 26px;
            float: right;
            cursor: pointer;
            z-index: 999;
          }
        }
        .child_comment {
          padding-left: 80px;
          color: rgba(102, 102, 102, 1);
          font-size: 26px;
          cursor: pointer;
        }
      }
    }
    .children_list {
      padding-left: 80px;
      .children_item {
        margin-top: 30px;
      }
    }
    .comment_footer {
      font-size: 28px;
      text-align: center;
      cursor: pointer;
    }
  }
  ::v-deep {
    .htmlClass {
      font-size: 30px !important;
      p {
        margin-bottom: 30px;
      }
      img {
        display: block;
        margin: 0 auto;
      }
    }
    .rich_pages{
      margin: 0 auto !important;
    }
    .article__author-info-box {
      display: flex;
      align-items: center;
      font-size: 30px;
      .article-author-info {
        display: flex;
        align-items: center;
      }
      .w-em {
        width: 80px;
        height: 80px;
      }
      img {
        margin-right: 10px;
      }
    }
    .no-referrer {
      width: 100% !important;
    }

    // .ql-align-center,
    // .ql-align-justify {
    //   width: 100%;
    //   img {
    //     width: 100% !important;
    //   }
    // }
  }
}
</style>
